import { getUserProperty } from '@atlassian/jira-common-rest/src/api/latest/user-properties';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { fireJsonOnlyErrorAnalytics } from '@atlassian/jira-servicedesk-common/src/utils/analytics';
import { UPSELL_DISMISSED_PROPERTY_KEY } from '../../constants';
import type { CmdbUpsellStoreAction } from '../../types';

export const fetchInitialState =
	(): CmdbUpsellStoreAction =>
	async ({ setState }, { atlassianAccountId }) => {
		try {
			await getUserProperty(atlassianAccountId, UPSELL_DISMISSED_PROPERTY_KEY);
			setState({
				userHasDismissed: true,
			});
		} catch (error) {
			if (error instanceof FetchError && error.statusCode === 404) {
				setState({
					userHasDismissed: false,
				});
			} else {
				fireJsonOnlyErrorAnalytics({
					error: error instanceof Error ? error : undefined,
					meta: {
						id: 'fetchUpsellDismissedProperty',
						packageName: 'jiraServiceManagementCmdbUpsellBanner',
					},
				});
			}
		}
	};
